{
  "display_name": "Andre",
  "household_name": "Andre's household",
  "institution_name": "Chase Bank",
  "integrations_url": "https://dev.hearthfire.ai/integrations",
  "last_error": "ITEM_LOGIN_REQUIRED — your Chase password changed and Plaid needs you to re-authenticate."
}
